class ScrollButtons {
  constructor(root) {
    this.root = root;
    this.target = this.root.querySelector("[data-scroll-buttons-target]");
    this.leftButton = this.root.querySelector("[data-scroll-buttons-left]");
    this.rightButton = this.root.querySelector("[data-scroll-buttons-right]");

    this.leftButton.addEventListener("click", this.scrollLeft.bind(this));
    this.rightButton.addEventListener("click", this.scrollRight.bind(this));
  }

  scrollLeft() {
    this.target.scrollTo({
      left: this.target.scrollLeft - this.target.clientWidth,
      behavior: "smooth",
    });
  }

  scrollRight() {
    this.target.scrollTo({
      left: this.target.scrollLeft + this.target.clientWidth,
      behavior: "smooth",
    });
  }
}

class TabSwitcher {
  constructor(root) {
    this.root = root;
    this.tabButtons = Array.from(this.root.querySelectorAll(`[role="tab"]`));
    this.tabPanels = Array.from(this.root.querySelectorAll(`[role="tabpanel"]`));

    this.tabButtons.forEach(button => {
      button.addEventListener("click", this.tabButtonClicked.bind(this));
    });
  }

  tabButtonClicked(event) {
    const tabButton = event.currentTarget;
    const tabPanel = document.getElementById(tabButton.getAttribute("aria-controls"));
    this.tabButtons.forEach(x => { x.removeAttribute("aria-selected"); });
    this.tabPanels.forEach(x => { x.hidden = true; });
    tabButton.setAttribute("aria-selected", "true");
    tabPanel.hidden = false;
  }
}

function main() {
  for (const element of document.querySelectorAll("[data-tab-switcher]")) {
    element.tabSwitcher = new TabSwitcher(element);
  }

  for (const element of document.querySelectorAll("[data-scroll-buttons]")) {
    element.scrollButtons = new ScrollButtons(element);
  }
}

main();
